<template>
    <div>
        <el-button type="success" size="mini" @click="getdata">选择导师</el-button>
        <el-dialog
            title="导师列表"
            :visible.sync="showdialog"
            width="900px"
            append-to-body>
             <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.putaway" placeholder="请选择" clearable filterable>
                                <el-option v-for="(item, index) in putArr"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="照片" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="serve" label="服务人数"></el-table-column>
                        <el-table-column prop="bargain" label="成交套数"></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="236">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="relevance(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'TutorList',
    data() {
        return {
            form: {
                name: '',
                putaway: '',
            },
            putArr: ['显示', '不显示'],
            tabledata: [],
            pageNo: 1,
            pagesize: 8,
            total: 0,
            showdialog: false,
        }
    },
    methods: {
        relevance(item) {
            this.$emit('getTutor', item);
            this.showdialog = false;
        },
        getdata() {
            this.showdialog = true;
            this.getTabledata();
        },
        getTabledata() {
            var params = {
                name: this.form.name,
                putaway: this.form.putaway,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getTutorList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1
            this.getTabledata();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.ltpic{
    width: 200px;
    height: 200px;
}
</style>